//@ts-nocheck
import React from "react";
import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Select,
  Flex,
  Input,
  Button,
  Text,
  Textarea,
  Box,
  HStack,
} from "@chakra-ui/react";
import { EditContainer } from "./Shared";

const ButtonLink = ({ node = Button, children, ...rest }) => {
  let className = "button nowrap";
  let style = { cursor: "pointer", padding: "7px", marginRight: "10px" };
  return React.createElement(node, { ...rest, className, style }, children);
};

const styles = {
  parent: {
    marginBottom: 20,
  },
  FormGroup: {
    marginBottom: 10,
  },
  label: {
    marginRight: 10,
    marginBottom: 10,
    width: "15%",
    display: "inline-block",
  },
  input: {
    width: "70%",
  },
};

const FormGroup = ({ label, children }) => (
  <Flex my={5}>
    <label style={styles.label}>{label}</label>
    {children}
  </Flex>
);

const DefaultUpdateRemark = ({
  defaultContent,
  actions = [],
  onUpdateRemark,
  request_id,
  onClose,
  setContent,
  children,
  afterAction = null,
}) => {
  const [fields, setFields] = React.useState({
    remark: defaultContent,
    action: actions[0].value,
  });
  const [loading, setLoading] = React.useState(false);

  function updateFields(key, value) {
    setFields({ ...fields, [key]: value });
  }
  function updateRemark(e) {
    e.preventDefault();
    setLoading(true);
    onUpdateRemark(request_id, fields).then((data) => {
      const { content, remarks } = data;
      setContent(content);
      setLoading(false);
      if (afterAction) {
        afterAction(fields.action, remarks);
        onClose();
      } else {
        onClose();
      }
    });
  }
  function disableSubmit() {
    let result =
      Object.keys(fields)
        .map((x) => fields[x])
        .filter((x) => x.trim().length > 0).length !== 2;
    return result;
  }
  function getDate() {
    let dd = new Date();
    return `${dd.getFullYear()}-${dd.getMonth() + 1}-${dd.getDate()}`;
  }

  return (
    <React.Fragment>
      <fieldset className="module aligned ">
        <Text
          fontSize="xl"
          fontWeight="bold"
          align="center"
        >{`Update Remark`}</Text>
        <FormGroup label="Action:">
          <Select
            onChange={(e) => updateFields("action", e.target.value)}
            value={fields.action}
          >
            {actions.map((remarkAction, index) => {
              return (
                <option key={remarkAction.value} value={remarkAction.value}>
                  {remarkAction.label}
                </option>
              );
            })}
          </Select>
        </FormGroup>
        <FormGroup label={`Remark:`}>
          {fields.action === "call_client_later" ? (
            <Input
              type="date"
              value={fields.remark}
              onChange={(e) => updateFields("remark", e.target.value)}
            />
          ) : (
            <Textarea
              rows={4}
              value={fields.remark}
              onChange={(e) => updateFields("remark", e.target.value)}
            />
          )}
        </FormGroup>
        {children}
      </fieldset>
      <Flex justifyContent="space-between">
        <Button onClick={onClose} colorScheme="red">
          Close Modal
        </Button>
        <Button
          colorScheme="green"
          onClick={(e) => {
            updateRemark(e);
          }}
          type="submit"
          isLoading={loading}
          loadingText="Updating"
        >
          Update Remark
        </Button>
      </Flex>
    </React.Fragment>
  );
};

const RemarkApp = ({
  request_id,
  content: defaultContent = "",
  onUpdateRemark,
  actions = [],
  setDefaultRemark = true,
  children = null,
  childNode = undefined,
  afterAction = null,
  displayContent = true,
}) => {
  const [edit, setEdit] = React.useState(true);
  const [content, setContent] = React.useState(
    setDefaultRemark ? defaultContent : "",
  );

  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <React.Fragment>
        {displayContent && (
          <Box>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </Box>
        )}
        {edit ? (
          <Button
            colorScheme="blue"
            onClick={onOpen}
            height="25px"
            px="5px"
            fontSize="10px"
          >
            Update Remark
          </Button>
        ) : null}
      </React.Fragment>
      <EditContainer isOpen={isOpen} onClose={onClose}>
        <DefaultUpdateRemark
          actions={actions}
          onClose={onClose}
          defaultContent={content}
          onUpdateRemark={onUpdateRemark}
          request_id={request_id}
          setContent={setContent}
          afterAction={afterAction}
        >
          {children}
        </DefaultUpdateRemark>
      </EditContainer>
    </>
  );
};

export default RemarkApp;
